var exports = {
  "Nr": "VoiceSceneShortcutCard.module__card___akFXTG",
  "Lv": "VoiceSceneShortcutCard.module__intro___akFXTG",
  "wx": "VoiceSceneShortcutCard.module__header___akFXTG",
  "gr": "VoiceSceneShortcutCard.module__titleIcon___akFXTG",
  "DD": "VoiceSceneShortcutCard.module__title___akFXTG",
  "VN": "VoiceSceneShortcutCard.module__close___akFXTG",
  "ut": "VoiceSceneShortcutCard.module__closeIcon___akFXTG",
  "TN": "VoiceSceneShortcutCard.module__groups___akFXTG",
  "Os": "VoiceSceneShortcutCard.module__group___akFXTG",
  "SZ": "VoiceSceneShortcutCard.module__groupTitle___akFXTG",
  "n8": "VoiceSceneShortcutCard.module__line___akFXTG",
  "bQ": "VoiceSceneShortcutCard.module__lineLabel___akFXTG",
  "HP": "VoiceSceneShortcutCard.module__keys___akFXTG",
  "o0": "VoiceSceneShortcutCard.module__joiner___akFXTG",
  "Eb": "VoiceSceneShortcutCard.module__key___akFXTG",
  "C$": "VoiceSceneShortcutCard.module__introIn___akFXTG",
  "Xz": "VoiceSceneShortcutCard.module__introTitle___akFXTG",
  "fY": "VoiceSceneShortcutCard.module__introItems___akFXTG",
  "yb": "VoiceSceneShortcutCard.module__introItem___akFXTG",
  "O1": "VoiceSceneShortcutCard.module__timer___akFXTG",
  "m1": "VoiceSceneShortcutCard.module__introTimer___akFXTG",
};

module.exports = exports;
